import React, { useCallback, useMemo, useRef, useState } from 'react';

import AlertDialog from '@src/components/dialog/AlertDialog';

const AlertContext = React.createContext();
import { ALERT_ACTIONS } from './constants';

function AlertProvider({ children }) {
  const resolvePromise = useRef(null);

  const [state, setState] = useState({ open: false });

  const open = useCallback((props) => {
    setState({ ...props, open: true });
    return new Promise((resolve) => {
      resolvePromise.current = resolve;
    });
  }, []);

  const close = useCallback(({ action = ALERT_ACTIONS.CLOSE }) => {
    setState((prevState) => ({ ...prevState, open: false }));
    resolvePromise.current({ action });
  }, []);

  const handleCloseModal = useCallback(() => {
    close({ action: ALERT_ACTIONS.CANCEL });
  }, [close]);

  const handleSubmitModal = useCallback(() => {
    close({ action: ALERT_ACTIONS.CONFIRM });
  }, [close]);

  const contextValue = useMemo(() => ({ open, close, ALERT_ACTIONS }), [open, close]);

  return (
    <AlertContext value={contextValue}>
      {children}

      <AlertDialog
        {...state}
        disableEnforceFocus
        onClose={handleCloseModal}
        onConfirm={handleSubmitModal}
      />
    </AlertContext>
  );
}

export {AlertContext, AlertProvider};
